import { Box } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import Xarrow, { useXarrow, Xwrapper } from "react-xarrows";
import usePipelineStore from "../../stores/pipeline-store";
import useRuntimeStore from "../../stores/runtime-store";
import StepArrows from "./StepArrows";
import StepNode from "./StepNode";

const PipelineSchema = ({}) => {
    const { pipeline } = usePipelineStore((state: any) => state);
    const { pageDelta, setPageDelta } = useRuntimeStore((state: any) => state);
    return (
        <Box flex="1" overflow={"auto"} bgColor={"gray.100"} zIndex={0}>
            <Xwrapper>
                <div
                    style={{
                        position: "relative",
                        height: "10000px",
                        width: "10000px",
                    }}
                    onWheel={(event: any) => {
                        setPageDelta({
                            x: Math.max(0, pageDelta.x + event.deltaX),
                            y: Math.max(0, pageDelta.y + event.deltaY),
                        });
                    }}
                >
                    {(pipeline as PipelineJson).editorSettings.stepIds.map(
                        (stepId) => {
                            return <StepNode key={stepId} stepId={stepId} />;
                        }
                    )}
                    <StepArrows />
                </div>
            </Xwrapper>
        </Box>
    );
};

export default PipelineSchema;
